import { createApi } from "@reduxjs/toolkit/query/react";
import { privateBaseQuery } from "../base/private/privateBaseQuery";

export type ProductShipmentType = "cyfral" | "physical";
export type ProductPaymentType = "forever" | "subscribe" | "voucher";
export type ProductType = "assignment" | "course" | "group";

export interface ProductPayload {
    id?: number | null;
    currency_id: number;
    status: string;
    type: ProductType;
    shipment_type: ProductShipmentType;
    payment_type: ProductPaymentType;
    price: number;
    quantity?: number | null;
    image: string | null;
    color?: string | null;
    name: string;
    description?: string | null;
    formatted_price?: string | null;
    is_acquired?: boolean;
}

export interface ProductEntity extends ProductPayload {
    id: number;
    is_acquired: boolean;
}

interface CreateProductResponse {
    status: string;
    status_code: string;
    entity: ProductEntity;
}

export const productApi = createApi({
    reducerPath: "productApi",
    baseQuery: privateBaseQuery(),
    tagTypes: ["Product"],
    endpoints: (builder) => ({
        createProduct: builder.mutation<ProductEntity, ProductPayload>({
            query: (payload) => ({
                url: "/products",
                method: "POST",
                data: payload,
            }),
            transformResponse: (response: CreateProductResponse | ProductEntity) => {
                if ((response as CreateProductResponse).entity) {
                    return (response as CreateProductResponse).entity;
                }
                return response as ProductEntity;
            },
            invalidatesTags: ["Product"],
        }),
    }),
});

export const { useCreateProductMutation } = productApi;